<template>
    <div class="report__list_grid">
        <div class="container">
            <div class="columns columns--custom is-3 is-multiline">
                <template v-for="(reportSlug, index) in reportSlugs">
                    <div
                        class="column column--custom is-4-widescreen is-6-desktop is-12-mobile"
                        :key="index">
                        <report-list-grid-item
                            :report-slug="reportSlug"
                            :report-titles="reportTitles[index]"
                        />
                    </div>
                </template>
            </div>
        </div>
        <a
            class="report__list_grid_hiddenlink hidden"
            id="download-report-csv"
        ></a>
    </div>
</template>

<script>
import ReportListGridItem from '@/components/ebs/reports/list/ReportListGridItem'

export default {
  components: { ReportListGridItem },
  name: 'report-list-grid',
  props: {
    reportSlugs: {
      type: [Array, Object]
    },
    reportTitles: {
      type: [Array, Object]
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/reportlistgrid";
</style>
